// src/index.js
import './styles/modernist.css';   // tokens first
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import MaintenanceGate from './components/maintenance/MaintenanceGate';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MaintenanceGate>
      <App />
    </MaintenanceGate>
  </React.StrictMode>
);

reportWebVitals();